<template>
  <div class="min-h-screen gap-4 flex flex-col bg-capino-light">
    <OnboardingHeader />

    <OnboardingQuiz
      class="py-8"
      :is-loading="isLoading"
      @quiz-completed="handleQuizCompleted"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import OnboardingHeader from '@/components/Onboarding/OnboardingHeader.vue'
import OnboardingQuiz from '@/components/Onboarding/OnboardingQuiz.vue'

export default {
  name: 'TheOnboarding',

  components: {
    OnboardingHeader,
    OnboardingQuiz
  },

  data: () => ({
    isLoading: false
  }),

  computed: {
    ...mapState('user', ['user'])
  },

  methods: {
    // ...mapMutations('ui', {
    //   setUiNewPaywallModalIsVisible: 'SET_UI_NEW_PAYWALL_MODAL_IS_VISIBLE'
    // }),
    ...mapActions('user', {
      updateQuizString: 'UPDATE_QUIZ_STRING'
    }),

    async handleQuizCompleted(quizData) {
      if (!this.user.quizString) {
        window?.datafast('onboarding-completed')

        const quizString = JSON.stringify(quizData)
        this.isLoading = true
        await this.updateQuizString({ quizString })
        this.isLoading = false
      }

      this.$router.push({ name: 'hub' })

      // if (this.user.isPremium) {
      //   this.$router.push({ name: 'hub' })
      // } else {
      //   this.setUiNewPaywallModalIsVisible(true)
      // }
    }
  }
}
</script>
